module.exports = __webpack_public_path__ + "img/51626503_L.11baea25.png";